import {Component} from '@angular/core';
import {WidgetControllerComponent} from '../../../../Controller/widget-controller-component';

@Component({
  selector: 'app-widget-home-core',
  templateUrl: './widget-home-core.component.html',
  styleUrls: ['./widget-home-core.component.scss'],
  standalone: false
})
export class WidgetHomeCoreComponent extends WidgetControllerComponent {
}
